import { Layout } from "antd";
import { Link } from "react-router-dom";
import UserProfile from "../../containers/Topbar/UserProfile";
import EventsWidget from "../../components/Events/Widget";
import {
   NAV_STYLE_DRAWER,
   NAV_STYLE_FIXED,
   NAV_STYLE_MINI_SIDEBAR,
   TAB_SIZE,
} from "../../constants/ThemeSetting";
import { layoutSettingsVar, globalSettingsVar } from "../../apollo/local/cache";
import { useQuery, useReactiveVar } from "@apollo/client";
import VerificationsWidget from "../../components/Dossier/VerificationsWidget";
import { GQL_LOCAL_ME } from "../../apollo/query/user";
import { Roles } from "../../constants/Enums";
import FeatureOverviewListWidget from "../../components/FeatureOverview/widget";
import TaskManagerToolbarIcon from "../../components/TaskManager/TaskManagerToolbarIcon";
import MEFToolbarIcon from "../../components/MEF/MEFToolbarIcon";
import { isClient } from "../../acl/helpers";
import UserNotificationDispatcher from "./UserNotificationDispatcher";
import NotificationRequestBanner from "./NotificationRequestBanner";
import { useIsMobileVersion } from "../../hooks/useIsMobileVersion";
import { useIntl } from "react-intl";

const { Header } = Layout;

const Topbar = ({ user }) => {
   const intl = useIntl();
   const isMobileVersion = useIsMobileVersion();
   var { navStyle } = useReactiveVar(layoutSettingsVar);
   var { width, sideBarCollapsed } = useReactiveVar(globalSettingsVar);
   const logoClassName = sideBarCollapsed ? "gx-d-lg-block" : "gx-d-lg-none";

   const { data } = useQuery(GQL_LOCAL_ME);

   return (
      <>
         <Header style={{ padding: 0 }}>
            {navStyle === NAV_STYLE_DRAWER ||
            ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) &&
               width < TAB_SIZE) ? (
               <div className="gx-linebar gx-mr-3">
                  <i
                     className="gx-icon-btn icon icon-menu"
                     onClick={(e) => {
                        e.stopPropagation();
                        globalSettingsVar({
                           ...globalSettingsVar(),
                           navCollapsed: true,
                        });
                     }}
                  />
               </div>
            ) : null}

            <Link to="/" className={`gx-d-block ${logoClassName} gx-pointer`}>
               <img alt="" src="/assets/images/logo-small.png" height={34} />
            </Link>

            {!isClient(user) && !isMobileVersion && (
               <ul style={{ listStyleType: "none", display: "flex" }}>
                  <li className="gx-notify gx-mr-3" style={{ marginTop: -3 }}>
                     <TaskManagerToolbarIcon />
                  </li>
                  <li className="gx-notify gx-mr-3" style={{ marginTop: -3 }}>
                     <MEFToolbarIcon />
                  </li>
               </ul>
            )}

            {isMobileVersion && (
               <ul className="gx-header-notifications gx-ml-2">
                  <li>{intl.formatMessage({ id: "common.mobile_version" })}</li>
               </ul>
            )}

            <ul className="gx-header-notifications gx-ml-auto">
               {!isMobileVersion && (
                  <li className="gx-notify gx-mr-3">
                     <FeatureOverviewListWidget />
                  </li>
               )}

               {!isMobileVersion &&
                  [Roles.SUPERADMIN, Roles.ADMIN].includes(data?.me?.user_type) && (
                     <>
                        <li className="gx-notify gx-mr-3">
                           <EventsWidget />
                        </li>
                        <li className="gx-notify gx-mr-3">
                           <VerificationsWidget />
                        </li>
                     </>
                  )}
               <li className="gx-notify">
                  <UserProfile />
                  <UserNotificationDispatcher />
               </li>
            </ul>
         </Header>

         {!isMobileVersion && <NotificationRequestBanner />}
      </>
   );
};

export default Topbar;
